module.exports = __webpack_public_path__ + "static/img/cat.85a1ec93.png";